import i18n, { t } from 'i18next';
import styled from '@emotion/styled';

type P = {
  keyword?: string;
  searchCount?: number;
};

const SearchKeywordResult = ({ keyword, searchCount = 0 }: P) => {
  const isEn = i18n.language === 'en';

  return (
    <>
      {isEn ? (
        <div style={{ display: 'flex', minWidth: 0, flex: 1, fontWeight: 500 }}>
          <span style={{ color: 'var(--dk-accent, #06C)' }}>{searchCount}</span>
          <div> results found for </div>
          <span>‘</span>
          <StyledKeyword>{`${keyword}`}</StyledKeyword>
          <span>’</span>
        </div>
      ) : (
        <div style={{ display: 'flex', minWidth: 0, flex: 1, fontWeight: 500 }}>
          <span>‘</span>
          <StyledKeyword>{`${keyword}`}</StyledKeyword>
          <span>’</span>
          <div>{t('에 대한 총') + ' '}</div>
          <span style={{ color: 'var(--dk-accent, #06C)' }}>{searchCount}</span>
          <div>{t('건의 검색결과')}</div>
        </div>
      )}
    </>
  );
};

export default SearchKeywordResult;

const StyledKeyword = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  max-width: fit-content;
  font-weight: 700;
`;
